// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_bundle: PokeData = {
  "id": 991,
  "name": "iron-bundle",
  "height": 6,
  "weight": 110,
  "base_experience": 285,
  "types": [
    PokeType.ICE,
    PokeType.WATER
  ],
  "api_moves": [
    "take-down",
    "hydro-pump",
    "ice-beam",
    "blizzard",
    "drill-peck",
    "agility",
    "powder-snow",
    "present",
    "whirlpool",
    "helping-hand",
    "freeze-dry",
    "aurora-veil",
    "flip-turn",
    "snowscape"
  ],
  "moves": [
    "hydro-pump",
    "blizzard",
    "agility",
    "whirlpool",
    "aurora-veil",
    "ice-shard",
    "ice-wave",
    "life-dew",
    "rain-dance",
    "water-spout",
    "bubble",
    "bubble-beam",
    "ice-punch"
  ],
  "evolution_chain": {
    "id": 522,
    "item": null,
    "species": [
      {
        "name": "iron-bundle",
        "order": 992,
        "types": [
          PokeType.ICE,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 86,
    "speed": 164,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
